// extracted by mini-css-extract-plugin
module.exports = {"root":"_6a5a6d","pageContentContainer":"_43f6e2","title":"_9b0ddc"};